module.exports = __webpack_public_path__ + "img/throughthepandemic_final-11.061ef0c7.jpg";